/** returns if at least one of the mandatory items is empty
@list { Object }
@mandatoryList { Array }
@return { Boolean }
*/
export const atLeastOneIsEmpty = (list, mandatoryList) => {
	for (var item in list) {
		if (mandatoryList.find(obj => obj === item)) {
			if (list[item] === null || list[item].length === 0 || list[item] === 0) return true
		}
	}
	return false
}

/** returns if at least one of the mandatory items is empty
@list { Object }
@mandatoryList { Array }
@return { Boolean }
*/
export const getEmptyFieldsIdentifiers = (list, mandatoryList) => {
	const emptyFieldsIdentifiers = []
	for (var item in list) {
		if (mandatoryList.find(obj => obj === item)) {
			if (list[item] === null || list[item].length === 0 || list[item] === 0) emptyFieldsIdentifiers.push(item)
		}
	}
	return emptyFieldsIdentifiers
}

/** returns the object with the options cleared
@object { Object }
@return { Object }
*/
export const clearObject = object => {
    for (var key in object) {
        object[key] = null
    }
    return object
}

/** returns the object with the options cleared
@object { Object }
@return { Object }
*/
export const clearObjectStrings = object => {
    for (var key in object) {
        object[key] = ''
    }
    return object
}
